import script from "./UserQuestionListPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserQuestionListPage.vue?vue&type=script&setup=true&lang=ts"

import "./UserQuestionListPage.vue?vue&type=style&index=0&id=b712f8ca&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b712f8ca"]])

export default __exports__